import React from "react";
import { InstallModal } from "../../../shared/components/InstallModal";

type CTASectionProps = {
  modalOpen: boolean;
  onInstall: () => void;
  onCloseModal: () => void;
};

export default function CTASection({ modalOpen, onInstall, onCloseModal }: CTASectionProps) {
  return (
    <>
      <section className="home-cta">
        <div className="home-cta__copy">
          <h2>
            Meet together now on
            <br />
            HereWeAre!
          </h2>
          <p>
            Join us in the world of art and be invited to
            <br />
            an experience that will make the moment even more special.
          </p>
        </div>
        <button type="button" onClick={onInstall}>
          Let's Connect Now
          <img src="/assets/img/top-right-arrow.svg" alt="" />
        </button>
      </section>

      <InstallModal open={modalOpen} onClose={onCloseModal} />
    </>
  );
}
